<template>
    <div class="form-item"
         :class="{active: focused || filled}"
         @focus.capture="focused = true"
         @blur.capture="focused = false"
         @input.capture="checkFilled">
        <label v-bind="$attrs">
            <slot name="label">
                {{ label }}
            </slot>
        </label>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        props: ['label'],
        data: () => ({
            focused: false,
            filled: false,
        }),
        methods: {
            checkFilled(event = null) {
                let input = event ? event.target : this.input.elm;
                this.filled = !!(input && input.value);
            },
        },
        mounted() {
            this.input = this.$slots.default.filter(vnode => vnode.tag === 'input' || vnode.tag === 'textarea')[0];
            this.$slots.default.filter(vnode => vnode.tag === 'input' || vnode.tag === 'textarea')
                .map(vnode => vnode.elm)
                .forEach(elm => elm.dataset.component = '');
            this.checkFilled();
        },
    };
</script>



// WEBPACK FOOTER //
// assets/js/components/FloatingLabel.vue